/**
 * 処理ステータスの共有型定義
 *
 * フロントエンド・バックエンド両方で使用される統一ステータス型
 */
/**
 * ステータスマップ（UI表示用）
 */
export const STATUS_MAP = {
    received: { label: "処理中", color: "blue" },
    processing: { label: "処理中", color: "blue" },
    completed: { label: "完了", color: "green" },
    done: { label: "完了", color: "green" },
    success: { label: "完了", color: "green" },
    pending: { label: "保留中", color: "gray" },
    warning: { label: "警告あり", color: "orange" },
    error: { label: "エラー", color: "red" },
    failed: { label: "エラー", color: "red" },
    rejected: { label: "拒否", color: "red" },
    aborted: { label: "中断", color: "orange" },
};
/**
 * 未知のステータスに対するデフォルト設定
 */
export const DEFAULT_STATUS_CONFIG = {
    label: "処理中",
    color: "blue",
};
//# sourceMappingURL=status.js.map